<label class="label">{{ 'common.titles.methods' | translate }}</label>
<mat-radio-group
  color="primary"
  [(ngModel)]="publicationMethod"
  (change)="methodChange.emit(publicationMethod)"
>
  <mat-radio-button color="primary" class="publication-method" value="email">{{
    'common.titles.publishByEmail' | translate
  }}</mat-radio-button>
  <mat-radio-button color="primary" class="publication-method" value="link">{{
    'common.titles.publishByLink' | translate
  }}</mat-radio-button>
</mat-radio-group>
